module.exports = __webpack_public_path__ + "img/green-success.1c5055ee.svg";